"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
const micro_streaming = __importStar(require("@journeyapps-platform/micro-streaming"));
const streaming = __importStar(require("../streaming"));
const defs = __importStar(require("../definitions"));
const decoders = __importStar(require("./decoders"));
const codecs = __importStar(require("./codecs"));
const errors = __importStar(require("./errors"));
const defaultRetryStrategy = (attempt) => {
    return attempt * 200;
};
const createTimeout = (handler, timeout) => {
    let t = setTimeout(handler, timeout);
    let cleared = false;
    return {
        clear: () => {
            if (cleared) {
                return;
            }
            clearTimeout(t);
            cleared = true;
        },
        heartbeat: () => {
            if (cleared) {
                return;
            }
            clearTimeout(t);
            t = setTimeout(handler, timeout);
        }
    };
};
const request = async (url, params, attempt = 0) => {
    let headers;
    if (typeof params.headers === 'function') {
        headers = await params.headers();
    }
    else {
        headers = {
            ...(params.headers || {})
        };
    }
    headers = {
        [defs.Header.Accept]: '*/*',
        ...headers
    };
    if (params.user_agent) {
        headers[defs.Header.UserAgent] = params.user_agent;
    }
    let body;
    if (params.body) {
        if (streaming.isStreamedPayload(params.body)) {
            body = params.body.encode();
        }
        else {
            const content_type = headers[defs.Header.ContentType] || defs.ContentType.JSON;
            headers[defs.Header.ContentType] = content_type;
            const codec = params.codecs?.[content_type] || codecs.DEFAULT_CODECS[content_type];
            if (codec) {
                body = codec.encode(params.body);
            }
            else {
                if (!Buffer.isBuffer(params.body) && typeof params.body !== 'string') {
                    throw new Error(`Unsupported body with type ${typeof params.body} and a Content-Type of ${content_type}. None of the configured codecs know how to convert the given body to a Buffer or string. Please provide a compatible codec`);
                }
                body = params.body;
            }
        }
    }
    const retryStrategy = params.retry_strategy || defaultRetryStrategy;
    const abort_controller = new AbortController();
    const timeout = params.timeout ?? 60000;
    const read_timeout = params.read_timeout ?? 20000;
    let request_timeout;
    if (timeout > 0) {
        request_timeout = createTimeout(() => {
            abort_controller.abort();
        }, timeout);
    }
    const decoder = params.decoder || decoders.decodeServiceResponse;
    const max_attempts = (params.retry_attempts ?? 1) - 1;
    try {
        const res = await params.request(url, {
            signal: abort_controller.signal,
            method: params.method,
            headers: headers,
            body: body
        });
        // We throw here for it to be handled by the retry logic
        if (res.status >= 500 && params.retryable) {
            if (attempt <= max_attempts) {
                throw res;
            }
        }
        request_timeout?.clear();
        const request_metadata = {
            url,
            method: params.method.toUpperCase()
        };
        return {
            response: res,
            stream: async () => {
                if (res.status >= 300) {
                    throw await decoder(res, request_metadata);
                }
                let stream_timeout;
                return micro_streaming.readableFrom(res.body).pipeThrough(new micro_streaming.compat.Transform({
                    start(controller) {
                        if (read_timeout <= 0) {
                            return;
                        }
                        stream_timeout = createTimeout(() => {
                            controller.error(new errors.TimeoutError());
                        }, read_timeout);
                    },
                    transform(chunk, controller) {
                        stream_timeout?.heartbeat();
                        controller.enqueue(chunk);
                    },
                    flush() {
                        stream_timeout?.clear();
                    }
                }));
            },
            decode: () => decoder(res, request_metadata)
        };
    }
    catch (err) {
        request_timeout?.clear();
        if (!params.retryable || attempt > max_attempts) {
            if (err.name === 'AbortError') {
                throw new errors.TimeoutError();
            }
            throw err;
        }
        await new Promise((resolve) => {
            setTimeout(resolve, retryStrategy(attempt));
        });
        return (0, exports.request)(url, params, attempt + 1);
    }
};
exports.request = request;
